import React, { useState, useEffect, Fragment } from "react";
import { Col, Container, Row, Table, Image } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import PropTypes from "prop-types";
import {
  get_subscription_details,
  admin_payout_vendor,
} from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import Dialog from "@material-ui/core/Dialog";

import DialogContent from "@material-ui/core/DialogContent";
import { useHistory } from "react-router";
import {
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Alert from "react-s-alert";
import axios from "axios";
import { NEFT, serverApi } from "../../../../config/Keys";
import {
  CLEAR_LOADER,
  SET_LOADER,
  SINGLE_VENDOR_SETTLEMENT,
} from "../../../../store/types";
import { AdminTwilioCallingModal } from "../superAdminVendor/superAdminVendorTable/firstPageTable/AllVendorTableBody";
import SuperAdminChatWindowPopup from "../superAdminPendingVendors/SuperAdminChatWindowPopup";
import { SuperAdminSMS } from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import { SuperAdminNotification } from "../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import InfoToolTip from "../../../reusableComponents/InfoTooltipComponent";
import isEmpty from "../../../../store/validation/is-Empty";
import OrderViewModal from "../../../reusableComponents/OrderViewModal";
import ViewExpReqDetails from "../../../vendorDashboardComponents/Experiences/Experiencedashboard/ViewExpReqDetails";

const SuperadminPayoutViewDetails = (props) => {
  const [state, setState] = useState(0);
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [bankData, setBankData] = useState([]);
  const [showTip, setShowTip] = useState(false);
  const [tipBankData, setTipBankData] = useState({});
  const [showBlock, setShowBlock] = useState(false);
  const [reason, setReason] = useState("");
  const [blockData, setBlockData] = useState({ type: "", id: "", bType: "" });
  const [disabled, setDisabled] = useState(
    props.location && props.location.state && props.location.state.access
      ? props.location.state.access
      : false
  );

  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [orderDetail, setOrderDetail] = useState({});

  const [type, setType] = useState(0)


  const totalComission = (orders, comissionCode) => {
    let orderTotal = orders?.reduce((a, b) => parseFloat(a) + parseFloat(b?.offerSettlement === 'ADMIN' ? b.base_amount : (b.base_amount - b.discount?.amount)), 0) || 0;
    let percent = parseFloat(comissionCode?.description || 0);
    let comission = (orderTotal * percent) / 100;
    let gst = (comission * 18) / 100
    return comission + gst
  }

  const totalEventComission = (events, comissionCode) => {
    let newOrders = events?.filter(ele => !ele.blockSettlement);
    let orderTotal = newOrders?.reduce((a, b) => parseFloat(a) + parseFloat(b.paymentData?.totalAmount), 0) || 0;
    let percent = parseFloat(comissionCode?.description || 0);
    let comission = (orderTotal * percent) / 100;
    let gst = (comission * 18) / 100
    return comission + gst
  }

  const handleView = (data) => {
    setShowOrderDetail(true);
    setOrderDetail(data)
  }

  const showView = () => {
    setShowOrderDetail(false);
    setOrderDetail({});
  }

  const [data, setData] = useState(history.location?.state?.data);

  const [orderData, setOrderData] = useState(data?.orders || []);

  useEffect(() => {
    if (!data?.restaurant_id?.restaurant_name) {
      history.goBack()
    }
  }, [data])

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation
                  backIcon
                  link="/superadminopenitemsettlement"
                  displayText="Back"
                />
                <Container fluid>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div>
                        <div className="super_admin_add_vendor mb-1">
                          <h5 className="main_header_text">Payout Details</h5>
                        </div>
                      </div>
                      <div className="mb-4 f14-400">
                        Where user using same accounts for ordering and events still
                        that will be initiated differently.
                      </div>
                    </div>
                    <div className="f12-500">
                      Report Range Date :  {moment(data?.orderSettledId ? data?.orderSettledId?.payoutStartDate : data?.eventSettledId ? data?.orderSettledId?.payoutStartDate : data?.scanSettledId?.payoutStartDate).format('ll')} - {moment(data?.orderSettledId ? data?.orderSettledId?.payoutEndDate : data?.eventSettledId ? data?.orderSettledId?.payoutEndDate : data?.scanSettledId?.payoutEndDate).format('ll')}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-5">
                      <div className="d-flex align-items-center">
                        <div className="mr-3">
                          <img
                            //src="https://amealia.s3.amazonaws.com/1616416724030-media-desktop-candle-light-dining-at-radisson-hitech-city-2020-7-2-t-13-4-37.jpg"
                            src={data?.restaurant_id?.logo_url}
                            width="100px"
                            alt="restaurant logo"
                            title="restaurant logo"
                          />
                        </div>
                        <div>
                          <div className="f20-700">
                            {data?.restaurant_id?.restaurant_name || ""}
                          </div>
                          <div className="f14-400">
                            {data?.restaurant_id?.restaurant_address}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col"></div>
                    <div className="col-3">
                      <div className="mr-3 f14-400 just">
                        Restaurant Number
                        <div className="p- 2 f12-500">{data?.restaurant_id?.point_of_contact?.[0]?.phone_numbers?.[0]?.country_code || ""} {data?.restaurant_id?.point_of_contact?.[0]?.phone_numbers?.[0]?.mobile_number || ""}</div>
                        <div className="d-flex align-items-center">
                          {/* <AdminTwilioCallingModal
                            sendData={props?.data.point_of_contact}
                          />
                          <SuperAdminChatWindowPopup
                            data={props?.data}
                            text={"seating"}

                          />
                          <SuperAdminSMS dataSend={props?.data.vendor_id} />
                          <SuperAdminNotification dataSend={props?.data.vendor_id} /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 mb-3 p-2">
                    <hr />
                    {state === 0 && <div className="d-flex justify-content-between">
                      <div className="f12-500">
                        <div>Amount <br />to be Paid</div>
                        <div className="mt-3">₹ {((data?.orderSettledId?.total_amount || 0) + (data?.tipSettledId?.total_amount || 0))?.toFixed(2) || 0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Total <br />Tip Amount</div>
                        <div className="mt-3">₹ {data?.tipSettledId?.total_amount?.toFixed(2) || 0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Current <br />Settlement</div>
                        <div className="mt-3">₹ {((data?.orderSettledId?.total_amount || 0) + (data?.tipSettledId?.total_amount || 0))?.toFixed(2) || 0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Credit <br />Memo</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Debit<br /> Memo</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Reversal<br /> Credit Memo</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Reversal<br /> Debit Memo</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Disputed<br /> Amount</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Payment<br /> Gateway</div>
                        <div className="mt-3">{NEFT}</div>
                      </div>
                      <div className="f12-500">
                        <div>Commission<br /> </div>
                        <div className="mt-3">₹ {totalComission(data?.orders, data?.restaurant_id?.comissionCode).toFixed(2)}</div>
                      </div>
                    </div>}
                    {state === 1 && <div className="d-flex justify-content-between">
                      <div className="f12-500">
                        <div>Amount <br />to be Paid</div>
                        <div className="mt-3">₹ {(data?.expSettledId?.total_amount)?.toFixed(2) || 0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Current <br />Settlement</div>
                        <div className="mt-3">₹ {(data?.expSettledId?.total_amount)?.toFixed(2) || 0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Credit <br />Memo</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Debit<br /> Memo</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Reversal<br /> Credit Memo</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Reversal<br /> Debit Memo</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Disputed<br /> Amount</div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>Payment<br /> Gateway</div>
                        <div className="mt-3">{NEFT}</div>
                      </div>
                      <div className="f12-500">
                        <div>Commission<br /> </div>
                        <div className="mt-3">₹ {totalEventComission(data?.expRequests, data?.restaurant_id?.comissionCode).toFixed(2)}</div>
                      </div>
                    </div>}
                    <hr />
                  </div>
                  <div>
                    <div className="f14-700 mt-3  mb-3">Payable orders</div>
                    <div className="d-flex justify-content-between">
                      <div className="w-50">
                        <div className="d-flex">
                          <div
                            className={`mr-5 ml-3 ${state === 0 && `selected-global-catalogue `
                              } f12-500`}
                            onClick={() => setState(0)}
                            style={{ cursor: "pointer" }}
                          >
                            Orders
                          </div>
                          <div
                            className={`mr-5 ml-3 ${state === 1 && `selected-global-catalogue `
                              } f12-500`}
                            onClick={() => setState(1)}
                            style={{ cursor: "pointer" }}
                          >
                            Experience
                          </div>
                          <div
                            className={`mr-5 ml-3 ${state === 2 && `selected-global-catalogue `
                              } f12-500`}
                            onClick={() => setState(2)}
                            style={{ cursor: "pointer" }}
                          >
                            Scan & Pay
                          </div>
                        </div>
                        <hr />
                      </div>
                      {/* <div>
                        <RightMenuStatus onTypeChange={onTypeChange} type={type} />
                        <hr />
                      </div> */}
                    </div>
                  </div>
                  <div>
                    <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                      <Table>
                        <thead>
                          <TableHead
                            display={
                              state === 0 ? (
                                <tr>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Order Type/ <br />
                                    Order ID
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Subtotal <br /> Of Items
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Discount
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Net Order <br /> Value
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Taxes
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Surcharges
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Tip
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Amount <br />Paid
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Outgoing <br /> Charges + GST
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Commission <br />+ GST
                                  </th>
                                  <th
                                    style={{ width: "12%" }}
                                    className="f12-500"
                                  >
                                    Amount to<br /> be Settled
                                  </th>
                                </tr>
                              ) : null
                            }
                            displayevents={
                              state === 1 ? (
                                <tr>
                                  <th
                                    style={{ width: "14%" }}
                                    className="f12-500"
                                  >
                                    My Experience/
                                    <br />
                                    Experience ID
                                  </th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="f12-500"
                                  >
                                    Subtotal <br /> Ticket Amount
                                  </th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="f12-500"
                                  >
                                    Net <br /> Value
                                  </th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="f12-500"
                                  >
                                    Amount Paid
                                  </th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="f12-500"
                                  >
                                    Outgoing <br /> charges + GST
                                  </th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="f12-500"
                                  >
                                    Commission <br />
                                    + GST
                                  </th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="f12-500"
                                  >
                                    Amount to be
                                    <br />
                                    Settled
                                  </th>
                                </tr>
                              ) : null
                            }
                            displayscanpay={
                              state === 2 ? (
                                <tr>
                                  <th
                                    style={{ width: "15%" }}
                                    className="f12-500"
                                  >
                                    Payment Method/ <br />
                                    Transaction ID
                                  </th>
                                  <th
                                    style={{ width: "15%" }}
                                    className="f12-500"
                                  >
                                    User
                                  </th>
                                  <th
                                    style={{ width: "15%" }}
                                    className="f12-500"
                                  >
                                    Total
                                    <br />
                                    Amount
                                  </th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="f12-500"
                                  >
                                    Tip
                                  </th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="f12-500"
                                  >
                                    Donation
                                  </th>

                                  <th
                                    style={{ width: "15%" }}
                                    className="f12-500"
                                  >
                                    Payment Status
                                    <br />
                                    /Date & Time
                                  </th>
                                  <th
                                    style={{ width: "15%" }}
                                    className="f12-500"
                                  ></th>
                                </tr>
                              ) : null
                            }
                          />
                        </thead>
                        {/* {state === 0 &&
                          props &&
                          props.data &&
                          props.data.orders &&
                          props.data.orders.map((orderData, index) => (
                            <TableBody
                              orderData={orderData}
                              key={index}
                              showBlockPayment={showBlockPayment}
                              loader={props.auth.loader}
                            />
                          ))}
                        {state === 1 &&
                          props &&
                          props.data &&
                          props.data.event_requests &&
                          props.data.event_requests.map((eventData, index) => (
                            <TableBodyEvents
                              eventData={eventData}
                              key={index}
                              showBlockPayment={showBlockPayment}
                              loader={props.auth.loader}
                            />
                          ))}
                        {state === 2 &&
                          props &&
                          props.data &&
                          props.data.scan_and_pay &&
                          props.data.scan_and_pay.map((scanData, index) => (
                            <TableBodyScanAndPay
                              scanData={scanData}
                              key={index}
                              showBlockPayment={showBlockPayment}
                              loader={props.auth.loader}
                            />
                          ))} */}
                        {state === 0 &&
                          orderData.map((order, index) => (
                            <TableBody
                              orderData={order}
                              comissionCode={data?.restaurant_id?.comissionCode}
                              key={index}
                              loader={props.auth.loader}
                              handleView={handleView}
                            />
                          ))}
                        {state === 1 &&
                          data?.expRequests?.map((eventData, index) => (
                            <TableBodyEvents
                              eventData={eventData}
                              comissionCode={data?.restaurant_id?.comissionCode}
                              key={index}
                              loader={props.auth.loader}
                              showBlockPayment={() => { }}
                            />
                          ))}
                        {state === 2 &&
                          data?.scan_and_pay?.map((scanData, index) => (
                            <TableBodyScanAndPay
                              scanData={scanData}
                              key={index}
                              loader={props.auth.loader}
                            />
                          ))}
                      </Table>
                    </div>
                  </div>
                </Container>
              </div>
            </div>
          </div>
          {showOrderDetail && <OrderViewModal orderDetails={orderDetail} handleClose={showView} />}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

SuperadminPayoutViewDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  get_subscription_details: PropTypes.func.isRequired,
  admin_payout_vendor: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  data: state.superadminManageTransactions.single_vendor_settllement,
});

export default connect(mapStateToProps, {
  get_subscription_details,
  admin_payout_vendor,
})(SuperadminPayoutViewDetails);

const TableHead = (props) => {
  return (
    <>
      {props?.display}
      {props?.displayevents}
      {props?.displayscanpay}
    </>
  );
};

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const calcTaxes = (data) => {
    let tax = 0;
    if (!isEmpty(data)) {
      tax = Object.values(data).reduce(
        (a, b) => parseFloat(a) + parseFloat(b),
        0
      );
    }
    return tax.toFixed(2);
  };



  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges = (data?.outgoingCharges?.fee || 0) + (data?.outgoingCharges?.tax || 0);
    let donation = data.donation && data.donation.amount ? data.donation.amount : 0;
    let payAmount = data.settleAmount ? data.settleAmount : data.total_amount;
    let comission = orderComission(data, props?.comissionCode)
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges - comission;
      return orderPayAmount;
    }
    else {
      return orderPayAmount;
    }
  }

  const orderComission = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = ((order?.base_amount - (order?.offerSettlement === 'ADMIN' ? 0 : order?.discount?.amount || 0)) * comission) / 100;
    let gst = (value * 18) / 100
    return value + gst;
  }

  const orderComssionDetails = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (((order?.base_amount - (order?.offerSettlement === 'ADMIN' ? 0 : order?.discount?.amount || 0)) * comission) / 100).toFixed(2);
    let gst = ((value * 18) / 100).toFixed(2)
    return { fee: value, gst: gst }
  }

  const handleView = () => {
    props.handleView(props.orderData)
  }

  // const calcRazorpayCharges = (data) => {
  //   let transDetails = data.transactionDetails;
  //   let razorpayAmount = 0;
  //   transDetails.forEach((ele) => {
  //     if (ele.paid && ele.method === "RAZORPAY" && ele.type === "PAYMENT") {
  //       razorpayAmount += ele.amount;
  //     }
  //   });
  //   if (data.donation?.amount && razorpayAmount) {
  //     razorpayAmount = razorpayAmount - data.donation?.amount;
  //   }
  //   razorpayAmount = (razorpayAmount * 2) / 100;
  //   let tax = (razorpayAmount * 18) / 100;

  //   return (razorpayAmount + tax).toFixed(2);
  // };
  // console.log('Order');
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className={` cursor enGrayBorderBox sd_body_tr`}
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${props.orderData?.blockSettlement ? "#EE3A23" : "#06A200"
                    }`,
                }}
                onClick={showTr}
              >
                <td style={{ width: "12%" }}>
                  <div className="f12-500 text-break pl-3">
                    {props.orderData && props.orderData.order_type === 0
                      ? "Take Away"
                      : props.orderData && props.orderData.order_type === 1
                        ? "Curb Side"
                        : props.orderData && props.orderData.order_type === 3
                          ? "Dine-In"
                          : "Skip The Line"}
                    <br />
                    {props && props.orderData && props.orderData.order_id}
                  </div>
                </td>
                <td style={{ width: "12%" }}>

                  <div className="f12-500">
                    ₹ {props?.orderData?.base_amount?.toFixed(2) || 0}
                  </div>

                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.discount?.amount.toFixed(2) || 0}
                  </div>
                </td>

                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {((props?.orderData?.base_amount || 0) - (props?.orderData?.discount?.amount || 0)).toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 d-flex">
                      ₹{calcTaxes(props.orderData.gstAmount)}
                    </div>
                    <InfoToolTip title={"View the bifurcation of Taxes"} data={props.orderData.gstAmount} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹ {calcTaxes(props.orderData.surCharges)}
                    </div>
                    <InfoToolTip title={"View the bifurcation of Surcharges"} data={props.orderData.surCharges} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.tip?.amount || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.total_amount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {(parseFloat(props?.orderData?.outgoingCharges?.fee || 0) + parseFloat(props?.orderData?.outgoingCharges?.tax || 0)).toFixed(2)}
                    </div>
                    <InfoToolTip title={"Outgoing gateway charges + GST"} data={props.orderData.outgoingCharges} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹ {orderComission(props.orderData, props?.comissionCode).toFixed(2)}
                    </div>
                    <InfoToolTip title={"Comission + 18% GST"} data={orderComssionDetails(props.orderData, props?.comissionCode)} />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {amountToSettle(props.orderData).toFixed(2)}
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className={`row d-flex justify-content-between`}>
                        {props.orderData.disputeId &&
                          <>
                            <div className="f12-500">
                              <div>Dispute Id</div>
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Amount
                              <div className="mt-3">₹ 0</div>
                            </div>
                            <div className="f12-500">Disputed Items
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">Disputed Status
                              <div className="mt-3">N/A</div>
                            </div>
                          </>}
                        <div className="f12-500">
                          Due Date
                          <div className="mt-3">
                            {moment(props.orderData?.settleAfter).add(1, 'day').format("MM-DD-YYYY")}
                            <br />
                            {moment(props.orderData?.settleAfter).add(1, 'day').format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          No of Items
                          <div className="mt-3">{props?.orderData?.order_items?.length}</div>
                        </div>
                        <div className="f12-500">
                          Offer Type
                          <div className="mt-3">
                            {props?.orderData?.offerSettlement === 'ADMIN' ? 'Amealio Offer' : props?.orderData?.discount?.amount ? "Merchant Offer" : 'N/A'}
                          </div>
                        </div>
                        <div className="f12-500">
                          Order Date
                          <div className="mt-3"> {moment(props.orderData?.createdAt).format("MM-DD-YYYY")}
                            <br />
                            {moment(props.orderData?.createdAt).format("LT")}</div>
                        </div>
                        <div className="f12-500">
                          Payment Block
                          <div className="mt-3">{props?.orderData?.blockReason || "-"}</div>
                        </div>
                      </div>
                    </div>
                  </tr>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Payout Payment Method</div>
                          <div className="mt-3">{NEFT}</div>
                        </div>
                        <div className="f12-500">
                          Payment Terms
                          <div className="mt-3">T2</div>
                        </div>
                        <div className="f12-500">Incoming Gateway Charges + GST
                          <div className="d-flex align-items-center mt-3">
                            <div>₹ {(props?.orderData?.gatewayCharges?.fee || 0) + (props?.orderData?.gatewayCharges?.tax || 0)}</div>
                            <InfoToolTip title={"Incoming gateway charges + Taxes"} data={props.orderData.gatewayCharges} />
                          </div>
                        </div>
                        <div className="f12-500">Donation
                          <div className="mt-3">₹ {props?.orderData?.donation?.amount || 0}</div>
                        </div>
                        <div className="f12-500">
                          Amount Received
                          <div className="mt-3">
                            ₹ {(props?.orderData?.total_amount || 0)}
                          </div>
                        </div>
                        <div className="f12-500">
                          <div className="d-flex justify-content-around">
                            {props.orderData.disputeId &&
                              <div className="f10-400 m-2" align="center">
                                <img
                                  src={require("../../../../assets/images/iconButton/eye.png")}
                                  width="35px"
                                  alt="icon"
                                />
                                <br />
                                View <br /> Dispute
                              </div>}
                            <div className="f10-400 m-2" align="center" onClick={handleView}>
                              <img
                                src={require("../../../../assets/images/iconButton/eye.png")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              View <br /> Transaction
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const TableBodyEvents = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [data, setData] = useState({})

  const eventComission = (event, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = ((event?.paymentData?.totalAmount) * comission) / 100;
    let gst = (value * 18) / 100
    return value + gst;
  }

  const eventComssionDetails = (event, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (((event?.paymentData?.totalAmount) * comission) / 100).toFixed(2);
    let gst = ((value * 18) / 100).toFixed(2)
    return { fee: value, gst: gst }
  }

  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges = (data?.outgoingCharges?.fee || 0) + (data?.outgoingCharges?.tax || 0);
    let donation = Number(data?.paymentData?.donationAmount || 0);
    let payAmount = Number(data?.paymentData?.totalAmount);
    let comission = eventComission(data, props?.comissionCode)
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges - comission;
      return orderPayAmount;
    }
    else {
      return orderPayAmount;
    }
  }

  useEffect(() => {
    let comission = eventComission(props.eventData, props?.comissionCode).toFixed(2);
    let settle = amountToSettle(props.eventData).toFixed(2)
    let comissionDetails = eventComssionDetails(props.eventData, props?.comissionCode);
    setData({ comission, settle, comissionDetails })
  }, [props])

  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${props.eventData?.blockSettlement ? "#EE3A23" : "#06A200"
                    }`,
                }}
                onClick={showTr}
              >
                {/* // TODO Need to Maintain ENUM */}
                <td style={{ width: "14%" }}>
                  <div className="d-flex align-items-center ml-4">
                    <div className="f12-500 text-break">
                      {props?.eventData?.experienceId?.name}
                      <br />
                      {props?.eventData?.experienceId?.expId}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      {props?.eventData?.paymentData?.amount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      {props?.eventData?.paymentData?.totalAmount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      {props?.eventData?.paymentData?.totalAmount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {(parseFloat(props?.eventData?.outgoingCharges?.fee || 0) + parseFloat(props?.eventData?.outgoingCharges?.tax || 0)).toFixed(2)}
                    </div>
                    <InfoToolTip title={"Outgoing gateway charges + GST"} data={props?.eventData.outgoingCharges} />
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹ {data?.comission}
                    </div>
                    <InfoToolTip title={"Comission + 18% GST"} data={data?.comissionDetails} />
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      {data.settle}
                    </div>
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        {props.eventData?.disputeId &&
                          <>
                            <div className="f12-500">
                              <div>Dispute Id</div>
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Amount
                              <div className="mt-3">₹ 0</div>
                            </div>
                            <div className="f12-500">Disputed Items
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">Disputed Status
                              <div className="mt-3">N/A</div>
                            </div>
                          </>}
                        <div className="f12-500">
                          Due Date
                          <div className="mt-3">
                            {moment(props.eventData?.settleAfter).add(1, 'day').format("MM-DD-YYYY")}
                            <br />
                            {moment(props.eventData?.settleAfter).add(1, 'day').format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          Total PAX <br /> Ticket No.
                          <div className="mt-3">{props?.eventData?.adultCount || 0 + props?.eventData?.kidsCount || 0 + props?.eventData?.package?.adults || 0 + props?.eventData?.package?.kids || 0} <br /> {props?.eventData?.requestId}</div>
                        </div>
                        <div className="f12-500">
                          Payment Block
                          <div className="mt-3">{props?.eventData?.blockReason || "-"}</div>
                        </div>
                      </div>
                    </div>
                  </tr>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Payout Payment Method</div>
                          <div className="mt-3">{NEFT}</div>
                        </div>
                        <div className="f12-500">
                          Payment Terms
                          <div className="mt-3">T2</div>
                        </div>
                        <div className="f12-500">Incoming Gateway Charges + GST
                          <div className="d-flex align-items-center mt-3">
                            <div>₹ {(props?.eventData?.gatewayCharges?.fee || 0) + (props?.eventData?.gatewayCharges?.tax || 0)}</div>
                            <InfoToolTip title={"Incoming gateway charges + Taxes"} data={props.eventData.gatewayCharges} />
                          </div>
                        </div>
                        <div className="f12-500">Donation
                          <div className="mt-3">₹ {props?.eventData?.paymentData?.donationAmount || 0}</div>
                        </div>
                        <div className="f12-500">
                          <div className="d-flex justify-content-around">
                            {props.eventData?.disputeId &&
                              <div className="f10-400 m-2" align="center">
                                <img
                                  src={require("../../../../assets/images/iconButton/eye.png")}
                                  width="35px"
                                  alt="icon"
                                />
                                <br />
                                View <br /> Dispute
                              </div>}
                            {/* <div className="f10-400 m-2" align="center" onClick={() => props.handleShowClear(props.orderData)} style={{ cursor: "pointer" }}>
                              <img
                                src={require("../../../../assets/images/iconButton/Reset.svg")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              Reset <br /> to Clear
                            </div> */}
                            {/* <div className="f10-400 m-2" align="center" onClick={props.showBlockPayment(
                              props.eventData?.blockSettlement ? "UNBLOCK" : "BLOCK",
                              props.eventData._id,
                              "EXP"
                            )} style={{ cursor: "pointer" }}>
                              <img
                                src={require("../../../../assets/images/iconButton/block.png")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              {props.eventData?.blockSettlement ? 'Un-block' : "Block"} <br /> Payment
                            </div> */}
                            <div className="f10-400 m-2" align="center">
                              <div>
                                <ViewExpReqDetails dataSend={props.eventData} overRideStyles={{ width: "35px", height: "35px" }} />
                                View <br /> Transaction
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const TableBodyScanAndPay = (props) => {
  return (
    <React.Fragment>
      <tbody>
        <tr
          className="super_admin_all_users_table_body"
          style={{
            borderLeftWidth: "4px",
            borderLeftStyle: "solid",
            borderLeftColor: `${props.scanData?.blockSettlement ? "#EE3A23" : "#06A200"
              }`,
          }}
        >
          <td className="text-break" style={{ width: "15%" }}>
            <div className="f12-500">
              {props && props.scanData && props.scanData.transaction_type}
              <br />
              {props && props.scanData && props.scanData._id}
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="d-flex align-items-center">
              <Image src={""} width="20px" fluid />
              <div className="f12-500 text-break">
                {props.scanData && props.scanData.user_id}
                {/* zomaland
                <br />
                1245789632
                <br />
                Ticket booked */}
              </div>
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="f15-500">
              ₹ {props.scanData && props.scanData.amount}
            </div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f15-500">₹ {props?.scanData.tip || 0}</div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f15-500">₹ {props?.scanData.donation || 0}</div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="badge badge-success">Success</div>
            <div className="f12-500">
              {moment(props.scanData && props.scanData.createdAt).format(
                "MM-DD-YYYY"
              )}
              <br />{" "}
              {moment(props.scanData && props.scanData.createdAt).format("LT")}
            </div>
          </td>
          <td style={{ width: "15%" }}>
            {/* <div
              className="btn btn-danger"
              onClick={props.showBlockPayment(
                props.scanData?.blockSettlement ? "UNBLOCK" : "BLOCK",
                props.scanData._id,
                "SCAN"
              )}
            >
              {props.scanData?.blockSettlement
                ? "Unblock Payment"
                : "Block Payment"}
            </div> */}
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};


const StatusRightMenuArr = [
  { title: "All", value: 0 },
  { title: "Cleared", value: 1 },
  { title: "Open", value: 2 },
  { title: "Disputed", value: 3 },
  { title: "Blocked", value: 4 },
];


